/* global WWW_HOME_URL, PREFIX, AuthService */

import { startLoading } from '../../apps/components/Notifications'

export default {
  name: 'LoyaltyBanner',
  template: `
    <div class="loyalty-banner">
      <div class="loyalty-banner__wrapper">
        <div class="loyalty-banner__logo">
          <img src="https://res.cloudinary.com/maistra/image/upload/v1636445351/Loyalty/maistar-rewards-club.png" alt="Maistar Rewards Club" width="106" height="96">
        </div>

        <div class="loyalty-banner__text">
          <div>
            <h4 v-html="$t('loyaltyBanner.title')" />
            <p v-html="$t('loyaltyBanner.description')" />
          </div>
          <button
            @click="e => {startLoading('authStatus'); $AuthService.redirectSignup()}"
            class="button button--maistar">
            {{ $t('loyaltyBanner.button') }}
          </button>
          <button
            style="display: none;"
            @click="redirectToSignup"
            class="button button--maistar debug">debug
            {{ $t('loyaltyBanner.button') }}
          </button>
        </div>
      </div>
    </div>
  `,
  setup () {
    function redirectToSignup () {
      console.log('redirectToSignup')
      startLoading('authStatus')
      const redirectUri = `${WWW_HOME_URL.replace(/\/+$/, '')}${PREFIX}/loyalty/profile/`
      AuthService.redirectSignup({ redirectUri })
    }

    return { startLoading, redirectToSignup }
  },
}
